import { ReelWin } from "./ReelWin";

// import { betValueGlobal } from "../config/GlobalVariableConfig";

import { spinData /*, WinObject*/ } from '../server/getServerResposesFun';


import { betValueGlobal, RespinIndex } from "../config/GlobalVariableConfig";

// import { Manager } from "../core/Manager";

// import { sound } from "@pixi/sound";
import { casinoEventEmitter } from "../core/CasinoChannelHandler";
import { reelSpinEmitter } from "./ReelInit";


export class Reels extends ReelWin {

    // private uiReel: Ui;
    // private sessionId: string;
    // private multiplierText1: Text;

    constructor() {
        super();

    }

    public update() {

        this.updateReelWin()
    }

    // public setReelRunning(val: boolean) {
    //     this.running = val;
    // }

    private resetReelRunning(spinStype: string) {
        // this.running = true;

        if (spinStype === "BASE") {
            console.log("inside resetReelRunning Base")
            RespinIndex.reset();

            // this.multiplierValTotal = 0;
        }

        // this.resetMouseMeter();

        console.log("currentRespinIndex", RespinIndex.value, spinStype);

        this.resetReelOverlayContFromToggle();

        // for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
        //     this.allReelArray[reelNum].container.visible = true;
        // }

        // this.reelOverlayContainer.removeChildren();
        // this.reelOverlayContainer.destroy();
        // this.initReelOverlayContainer();

    }


    public async startPlay(spinStype: string): Promise<[number, number, number?]> {

        // if (!spinData.dataFeatched) {
        //     await this.waitForData();
        // }

        // Cleanup any existing listeners for 'betDeclined' before adding a new one
        casinoEventEmitter.removeAllListeners('betDeclined');

        // Create a promise that resolves when 'betDeclined' is emitted
        const betDeclinedPromise = new Promise((resolve) => {
            // 'once' ensures automatic cleanup after the event is handled
            casinoEventEmitter.once('betDeclined', () => resolve('BetDeclined'));
        });

        console.log("startPlay for Freegame", this.running, spinStype, RespinIndex.value, spinData.respins.length);


        this.winLines = [];
        this.resetReelRunning(spinStype);

        let freeGameTrigger = 0;
        let accumulatedsWinAmount = 0;
        let respinWin: number = 0;

        do {
            console.log("startPlay for Freegame", "inside do-while", RespinIndex.value);

            const respinType = RespinIndex.value === 0 ? "reveal" : spinData.respins[RespinIndex.value].type;
            console.log("respinType", respinType);

            if (respinType === "feature_enter") {
                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;
                console.log(`feature_enter triggered: ${freeGameTrigger}`);
                // this.running = false;

                const accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                RespinIndex.increase();

                return [freeGameTrigger, accumulatedsWinAmount];
            }
            else if (respinType === "feature_exit" || respinType === "max_win_reached") {
                freeGameTrigger = -1;
                const totalFeatureWin = spinData.respins[RespinIndex.value].accumulatedsWinAmount || 0;
                console.log(`Feature end triggered: ${freeGameTrigger}`);
                // this.running = false;
                RespinIndex.increase();


                if (respinType === "max_win_reached") {
                    // this.resetReelsMaxWin();
                    freeGameTrigger = -2;
                }

                // casinoChannel.publish('showMaxWinDialog');

                return [freeGameTrigger, totalFeatureWin, totalFeatureWin];
            }
            else if (respinType === "reveal" || respinType === "battleRespin" || respinType === "fs_reveal" || respinType === "fs_battleRespin") {



                const isNewSpin: boolean = (respinType === "reveal" || respinType === "fs_reveal");


                if (!isNewSpin) {
                    // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value - 1].respinMultiplier);
                    // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value - 1].surgeMeter);
                }


                // Race between the reels and the 'betDeclined' event
                const betPromiseResult = await Promise.race([
                    this.startReels(RespinIndex.value, isNewSpin, spinStype), // Reel logic
                    betDeclinedPromise, // Event bet decline
                ]);

                if (betPromiseResult === 'BetDeclined') {
                    console.log('Bet was declined, breaking out of startPlay.');
                    this.resetReelRunning(spinStype);

                    this.isBetDecline = true;

                    return [0, -1];
                }


                await this.animateAllWinningSymbols(RespinIndex.value);
                //await this.triggerOtherFeatures(RespinIndex.value);

                const currentWin = spinData.respins[RespinIndex.value].winAmount;
                if (currentWin >= 10 * betValueGlobal /*&& currentWin < 20 * betValueGlobal*/) {
                    // const randomIndex = Math.floor(Math.random() * 2); // 0, 1, or 2
                    // const winVariant = randomIndex == 0 ? `win_2` : `win_3`;       // "win_1", "win_2", or "win_3"
                    // reelSpinEmitter.emit('animateCharacter', 'win_2');
                }




                if (isNewSpin) {
                    respinWin = 0;
                    // this.setAccWinValue(0);
                }

                respinWin += spinData.respins[RespinIndex.value].winAmount;

                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                // Check for fs_battleRespin sequence end in free games
                if ((spinStype === "FREEGAME") &&
                    (respinType === "fs_reveal" || respinType === "fs_battleRespin") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "fs_battleRespin") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "max_win_reached")
                ) {
                    if (spinData.respins[RespinIndex.value].featureData?.isHoldAndSpin) {

                    } else {
                        RespinIndex.increase();

                        return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                    }

                }
                if (spinStype === "BASE" && spinData.respins[RespinIndex.value].featureData?.isHoldAndSpin) {
                    return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                }
                if (spinStype === "FREEGAME" && spinData.respins[RespinIndex.value].featureData?.isHoldAndSpin) {
                    await this.triggerOtherFeatures();
                    if (RespinIndex.value >= spinData.respins.length - 1) {
                        freeGameTrigger = -1;
                        if (spinData.respins[spinData.respins.length - 2].type === "max_win_reached") {
                            freeGameTrigger = -2;
                        }
                        accumulatedsWinAmount = spinData.respins[spinData.respins.length - 1].accumulatedsWinAmount;
                        return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                    } else {
                        respinWin += spinData.respins[RespinIndex.value].winAmount;
                        accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;
                        RespinIndex.increase();
                        return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                    }

                }
            }

            RespinIndex.increase();
            console.log(`Respin is done for index ${RespinIndex.value}`);

        } while (RespinIndex.value < spinData.respins.length);

        return [freeGameTrigger, accumulatedsWinAmount];  // Return final result if loop completes without early return
    }


    private triggerOtherFeatures(): Promise<void> {
        return new Promise<void>((resolve) => {
            reelSpinEmitter.emit('triggerFeature', resolve);
        })
    }



}